module.exports = __webpack_public_path__ + "img/home.4032a587.svg";